const volunteer_shifts = state => state.volunteer_shifts
const volunteer_shift = state => state.volunteer_shift
const volunteer_shifts_details = state => state.volunteer_shifts_details

export default {
  volunteer_shifts,
  volunteer_shift,
  volunteer_shifts_details
};
